import React, { useEffect } from 'react';
import UtbetalingSemesterContainer from './UtbetalingSemesterComponent';
import { EpiContext } from '../../Shared/Scripts/Store/EpiContext/Types';
import VeilederHounDto from '../Models/VeilederHounDto';
import { VeilederHounAppState } from '../Store';
import { connect } from 'react-redux';
import { Utbetalingsplan } from '../Models/Utbetalingsplan';
import contentResolver from '../../Shared/Scripts/Utilities/EpiContentResolver';
import { updateLiveMessage } from '../../Shared/Scripts/Utilities/LiveMessage';

interface ResultatOwnProps {
    utbetalingsplan: Utbetalingsplan;
}

type IResultatProps = ResultatOwnProps & MapStateToProps & {};

const IResultatComponent = (props: IResultatProps): JSX.Element => {
    const { utbetalingsplan, epiContext } = props;
    useEffect(() => {
        updateLiveMessage();
    }, []);
    return (
        <div className="c-veileder__panel c-veileder__panel--info c-veileder__panel--white-aubergine">
            <div className="c-veileder__panel-row">
                {utbetalingsplan.terminerhost && (
                    <UtbetalingSemesterContainer
                        tabellOverskriftKey="kolonneTittelHost"
                        terminer={utbetalingsplan.terminerhost}
                    />
                )}
                {utbetalingsplan.terminervar && (
                    <UtbetalingSemesterContainer
                        tabellOverskriftKey="kolonneTittelVar"
                        erVar={true}
                        terminer={utbetalingsplan.terminervar}
                    />
                )}
            </div>
            <div className="c-veileder__panel-row">
                <div className="c-veileder__content">
                    <h4 className="c-veileder__tittel c-veileder__tittel--info">
                        {contentResolver(epiContext, 'tittelVenstreSpalte')}
                    </h4>
                    {contentResolver(epiContext, 'venstreSpalte')}
                </div>
                <div className="c-veileder__content">
                    <h4 className="c-veileder__tittel c-veileder__tittel--info">
                        {contentResolver(epiContext, 'tittelHoyreSpalte')}
                    </h4>
                    {contentResolver(epiContext, 'hoyreSpalte')}
                </div>
            </div>
            <div className="c-veileder__panel-row">
                <div className="c-veileder__content c-veileder__content--center-content">
                    <div className="c-infoboks c-infoboks--egg-sunshine c-infoboks--small">
                        {contentResolver(epiContext, 'informasjonIBunnen')}
                    </div>
                </div>
            </div>
        </div>
    );
};

interface MapStateToProps {
    epiContext: EpiContext<VeilederHounDto>;
}

export default connect(
    (state: VeilederHounAppState): MapStateToProps => {
        return {
            epiContext: state.epiContext,
        };
    },
)(IResultatComponent);
